import React from 'react';

const CollegeCardSkeleton = ({ compact = false }) => {
  if (compact) {
    return (
      <div className="overflow-hidden rounded-2xl border border-white/70 bg-white/90 shadow-[0_16px_36px_-24px_rgba(15,23,42,0.28)]">
        <div className="flex gap-3 p-3">
          <div className="h-24 w-28 shrink-0 animate-pulse rounded-xl bg-gradient-to-r from-slate-200 via-slate-100 to-slate-200" />
          <div className="flex min-w-0 flex-1 flex-col">
            <div className="flex items-start gap-2.5">
              <div className="h-11 w-11 shrink-0 animate-pulse rounded-xl bg-slate-200" />
              <div className="flex-1 space-y-2">
                <div className="h-4 w-5/6 animate-pulse rounded-full bg-slate-200" />
                <div className="h-3 w-1/3 animate-pulse rounded-full bg-slate-200" />
              </div>
            </div>
            <div className="mt-3 h-3 w-2/3 animate-pulse rounded-full bg-slate-200" />
            <div className="mt-auto pt-4">
              <div className="h-3 w-24 animate-pulse rounded-full bg-slate-200" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-white/70 bg-white/90 shadow-[0_18px_45px_-24px_rgba(15,23,42,0.28)]">
      <div className="h-28 animate-pulse bg-gradient-to-r from-slate-200 via-slate-100 to-slate-200" />
      <div className="p-4">
        <div className="mb-3 flex items-start gap-3">
          <div className="h-14 w-14 animate-pulse rounded-2xl bg-slate-200" />
          <div className="flex-1 space-y-2">
            <div className="h-4 w-3/4 animate-pulse rounded-full bg-slate-200" />
            <div className="h-3 w-1/3 animate-pulse rounded-full bg-slate-200" />
          </div>
        </div>
        <div className="mb-4 h-3 w-2/3 animate-pulse rounded-full bg-slate-200" />
        <div className="h-10 w-full animate-pulse rounded-xl bg-slate-200" />
      </div>
    </div>
  );
};

export default CollegeCardSkeleton;
